module.exports = __webpack_public_path__ + "img/check.0bf233c2.svg";